import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=8eb0d700&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"
import style0 from "./Permission.vue?vue&type=style&index=0&id=8eb0d700&prod&scoped=true&lang=css"
import style1 from "./Permission.vue?vue&type=style&index=1&id=8eb0d700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb0d700",
  null
  
)

export default component.exports